<template>
  <div
    class="class-selection"
    v-if="currentClassSelection"
  >
    <div
      data-cy="class-selection"
      class="class-selection__selected-class selected-class"
      @click.stop="toggle"
    >
      <current-class class="selected-class__text" />
      <chevron-down class="selected-class__dropdown-icon" />
    </div>
    <widget-popover
      class="class-selection__popover"
      v-if="showPopover"
      @hide-me="showPopover = false"
    >
      <li
        :label="schoolClass.name"
        :item="schoolClass"
        data-cy="class-selection-entry"
        class="popover-links__link popover-links__link--large"
        v-for="schoolClass in me.schoolClasses"
        :key="schoolClass.id"
        @click="updateSelectedClassAndHidePopover(schoolClass)"
      >
        {{ schoolClass.name }}
      </li>
      <li
        class="popover-links__link popover-links__link--large popover-links__divider"
        data-cy="create-class-link"
        v-if="me.isTeacher && !me.readOnly"
        @click="closeSidebar"
      >
        <router-link
          :to="{ name: 'create-class' }"
          class="popover-links__link-with-icon"
        >
          <add-icon class="popover-links__icon" />
          <span>Klasse erfassen</span>
        </router-link>
      </li>
      <li
        class="popover-links__link popover-links__link--large popover-links__divider"
        @click="closeSidebar"
      >
        <router-link
          data-cy="old-classes-link"
          :to="{ name: 'old-classes' }"
        >
          Alte Klassen anzeigen
        </router-link>
      </li>
    </widget-popover>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent, ref } from 'vue';
import WidgetPopover from '@/components/ui/WidgetPopover.vue';
import CurrentClass from '@/components/school-class/CurrentClass.vue';
import { doUpdateSelectedClass } from '@/graphql/mutations';
import { SchoolClassNode } from '@/__generated__/graphql';
import { useSidebar } from '@/mixins/sidebar';
import { useMe } from '@/graphql/queries';

const ChevronDown = defineAsyncComponent(() => import('@/components/icons/ChevronDown.vue'));
const AddIcon = defineAsyncComponent(() => import('@/components/icons/AddIcon.vue'));

const { closeSidebar } = useSidebar();

const { me } = useMe();

const showPopover = ref(false);

const toggle = () => {
  showPopover.value = !showPopover.value;
};

const updateSelectedClassAndHidePopover = async (selectedClass: SchoolClassNode) => {
  await doUpdateSelectedClass({ input: { id: selectedClass.id } });
  showPopover.value = false;
  closeSidebar('profile');
};
const currentClassSelection = computed(() => {
  let currentClass = me.value.schoolClasses.find((schoolClass: SchoolClassNode) => {
    return schoolClass.id === me.value.selectedClass.id;
  });
  return currentClass || me.value.schoolClasses[0];
});
</script>

<style scoped lang="scss">
@import 'styles/helpers';

.class-selection {
  position: relative;
  cursor: pointer;
  margin-bottom: $medium-spacing;
  border-radius: 4px;

  &__popover {
    white-space: nowrap;
    top: 100%;
    left: 0;
    transform: translateY($small-spacing);
  }
}

.selected-class {
  width: 100%;
  box-sizing: border-box;
  padding: $small-spacing 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  &__text {
    line-height: $large-spacing;
    @include heading-4;
    margin-right: $small-spacing;
  }

  &__dropdown-icon {
    width: 20px;
    height: 20px;
    fill: $color-charcoal-dark;
  }
}
</style>
